import * as React from "react";
import {cx} from "emotion";

import "./dedupe-panel.scss";

import {cs}               from "@Common/react/chain-services";
import {InformationBadge} from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";
import {SliderCheckbox}   from "@Common/ui-components/slider-checkbox/slider-checkbox";

import {DedupeModal} from "./dedupe-modal/dedupe-modal";

export const DedupePanel = ({dedupe=undefined}) => (
    <div className={cx("dedupe-panel-3dd", {disabled: dedupe.disabled})}>
        <div className="line1">
            <div className="label" xd-qa-type="label" xd-qa-name="Exclude duplicates from the mailing">
                Exclude duplicates from the mailing ({dedupe.quantity ?? "--"})
            </div>
            {dedupe.addresses.loading ? (
                <i className="fa fa-spinner fa-pulse"/>
            ) : (
                SliderCheckbox({
                    ...dedupe.selected,
                    disabled: dedupe.disabled,
                    ...!dedupe.quantity && {
                        onChange: () => alert("No duplicated addresses found"),
                    },
                    xdQaName: "Exclude duplicates from the mailing",
                })
            )}

            {InformationBadge({
                getTooltip: () => (
                    <div>
                        <div>
                            Enable this option to deduplicate the mailing lists on your order. The mailing
                            list files in your account will not be altered; the deduplication will be applied
                            to the recipient records for this order only. Duplicates are identified by an
                            exact match on the full address only (Address 1, Address 2, City, State & Zip).
                        </div>
                        <div className="dedupe-mail-tooltip-60p">
                            The Deduplication Functionality is not supported on EDDM or Demographics Lists at this time.
                        </div>
                    </div>
                ),
                xdQaName: "Build Street List Street Name",
            })}
        </div>
        {dedupe.disabled ? (
            <div className="explain-disabled">
                De-duplication is only enabled after 2 or more address lists are selected
            </div>
        ) : (
            <div className="actions">
                {cs(
                    ["dedupeModal", (_, next) => DedupeModal({list: dedupe.addresses, next})],
                    ({dedupeModal}) => (
                        <a {...{
                            onClick: () => dedupeModal.show(),
                        }}>
                            View Duplicates
                        </a>
                    )
                )}
            </div>
        )}
    </div>
);
